import { useEffect, useState } from "react";

/**
 * Prüft ob das aktuelle Gerät einen Orientation-Sensor hat und ein "mobile-
 * artiges" Input-Modell nutzt (Touch + coarse pointer). Nur auf solchen
 * Geräten macht der Gyro-Button Sinn — auf Desktop mit Maus liefert
 * DeviceOrientationEvent zwar theoretisch true, aber es gibt keine Sensor-
 * Daten und der Button wäre nur verwirrend.
 *
 * Rückgabe: false beim ersten Render (SSR-safe), true erst nach dem ersten
 * useEffect. Der kurze Übergang verursacht keinen Layout-Shift, weil der
 * Gyro-Button die letzte Position der Icon-Reihe belegt.
 */
export function useHasGyroscope(): boolean {
    const [available, setAvailable] = useState(false);
    useEffect(() => {
        if (typeof window === "undefined") return;
        const hasTouch =
            "ontouchstart" in window || (navigator?.maxTouchPoints ?? 0) > 0;
        const coarsePointer =
            typeof window.matchMedia === "function" &&
            window.matchMedia("(hover: none) and (pointer: coarse)").matches;
        const hasOrientationApi =
            typeof (window as unknown as { DeviceOrientationEvent?: unknown })
                .DeviceOrientationEvent !== "undefined";
        setAvailable(hasTouch && coarsePointer && hasOrientationApi);
    }, []);
    return available;
}
